import React, { useEffect, useState } from "react";
const bee = require("../assets/LOGO.png");

const Header = () => {
  const [selectedTabId, setSelectedTabId] = useState("home");

  const myFunction = () => {
    var x = document.getElementById("navbar");
    if (x.className === "topnav") {
      x.className += " responsive";
    } else {
      x.className = "topnav";
    }
  };

  const onChangeTab = (e,tab) => {
    e.preventDefault()
    let offset = -1;
    switch (tab) {
      case "home":
        offset = document.getElementById("home").offsetTop;
        break;
      case "about":
        offset = document.getElementById("about-us").offsetTop;
        break;
      case "services":
        offset = document.getElementById("servies").offsetTop;
        break;
      case "contact":
        offset = document.getElementById("contact-us").offsetTop;
        break;
      default:
        break  
    }
    window.scrollTo({ top: offset, behavior: "smooth" });
    setSelectedTabId(tab);
    window.removeEventListener("scroll", handleScrollPage);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScrollPage);
    return () => {
      window.removeEventListener("scroll", handleScrollPage);
    };
  });

  function handleScrollPage() {
    const homePage = document.getElementById("home");
    const aboutPage = document.getElementById("about-us");
    const servicePage = document.getElementById("servies");
    const conatctPage = document.getElementById("contact-us");

    const homeHeight = homePage.offsetTop + homePage.clientHeight;
    const aboutHeight = aboutPage.offsetTop + aboutPage.clientHeight;
    const servicesHeight = servicePage.offsetTop + servicePage.clientHeight;
    const contactHeight = conatctPage.offsetTop + conatctPage.clientHeight;
    
    if (
      window.pageYOffset >= homePage.offsetTop &&
      window.pageYOffset < homeHeight
    ) {
      setSelectedTabId("home");
    } else if (
      window.pageYOffset >= aboutPage.offsetTop &&
      window.pageYOffset < aboutHeight
    ) {
      setSelectedTabId("about");
    } else if (
      window.pageYOffset >= servicePage.offsetTop &&
      window.pageYOffset < servicesHeight
    ) {
      setSelectedTabId("services");
    } else if (
      window.pageYOffset >= conatctPage.offsetTop &&
      window.pageYOffset < contactHeight
    ) {
      setSelectedTabId("contact");
    }
  }

  return (
    <div className="topnav navbar-fixed-top" id="navbar">
      <div className="logo">
        <a href="http://beehives.co.in/">
          <img src={bee} width="45" alt="BEEHIVES" />
        </a>
      </div>
      <div className="nv">
        <span
          className={`${selectedTabId === "home" ? "active-tab" : ""}`}
          onClick={(e) => onChangeTab(e,"home")}
        >
          Home
        </span>
        <span
          className={`${selectedTabId === "about" ? "active-tab" : ""}`}
          onClick={(e) => onChangeTab(e,"about")}
        >
          About
        </span>
        <span
          className={`${selectedTabId === "services" ? "active-tab" : ""}`}
          onClick={(e) => onChangeTab(e,"services")}
        >
          Services
        </span>
        <span
          className={`${selectedTabId === "contact" ? "active-tab" : ""}`}
          onClick={(e) => onChangeTab(e,"contact")}
        >
          Contact
        </span>
        <span className="icon" onClick={myFunction}>
          <i className="fa fa-bars"></i>
        </span>
      </div>
    </div>
  );
};

export default Header;
